<div class="list-header">
  <p class="list-title">
    <span
      class="material-icons-outlined"
      [ngClass]="{
        'icon-business': icon === 'business',
        'icon-apartment': icon === 'apartment',
        'icon-error': icon === 'error',
        'icon-person': icon === 'person',
        'icon-label': icon === 'label',
        'icon-check_circle': icon === 'check_circle'
      }"
    >
      {{ icon }}
    </span>

    <span class="title">{{ (title | async) || "" | translate }}</span>
  </p>

  <div class="search-container">
    <input
      [(ngModel)]="searchTerm"
      (ngModelChange)="onSearchChange($event)"
      type="text"
      class="search-input"
      [placeholder]="searchPlaceholder || '' | translate"
    />
    <button (click)="onClearSearch()" class="clear-filter-btn">
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>
    <button *ngIf="supervisor" class="plus" (click)="onAddNewItem()">
      <i class="fa fa-plus" aria-hidden="true"></i>
    </button>
  </div>
</div>
